import { render, staticRenderFns } from "./fieldList.vue?vue&type=template&id=6221034f&scoped=true"
import script from "./fieldList.vue?vue&type=script&lang=js"
export * from "./fieldList.vue?vue&type=script&lang=js"
import style0 from "./fieldList.vue?vue&type=style&index=0&id=6221034f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221034f",
  null
  
)

export default component.exports